import { combineReducers } from 'redux'
import affiliates, { STATE_KEY as AFFILIATES_STATE_KEY } from './affiliates'

export const STATE_KEY = 'affiliates'

const reducer = combineReducers({
	[AFFILIATES_STATE_KEY]: affiliates
})

export default reducer